export const columnApplication = [
  {
    Header: "delete",
    accessor: "delete",
  },

  {
    Header: "Вибраний товар",
    accessor: "name_ua",
  },
  {
    Header: "Додати",
    accessor: "toggle_q",
  },
  {
    Header: "Кількість",
    accessor: "quantity_application",
  },
  {
    Header: "Ціна UAH: ",
    accessor: "price_in_uah",
  },
  {
    Header: "Ціна USD: ",
    accessor: "price_sum",
  },
];
